import styles from './styles.module.scss';
import { useLottiePlayer } from '@starsoft/common/hooks';
import { LottieOrImage } from '@starsoft/common/components';
import ConfirmationCodeContent from './Code';
import { ConfirmationCodeProps } from './props';
import { TransTextWithDefault } from '@starsoft/common/components';
import { CoreImageProps } from '../../Image/props';
import { SettingsService } from '@starsoft/common/services';

/**
 * ConfirmationCode component that displays a confirmation code input with animation
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.label - Label text to display below animation
 * @param {boolean} props.withoutPadding - Whether to remove padding from container
 * @param {...ConfirmationCodeProps} props - Additional props passed to ConfirmationCodeContent
 * @returns {JSX.Element} Confirmation code component with animation and input
 */
export function ConfirmationCode(
  { label, withoutPadding, ...props }: ConfirmationCodeProps,
  imageProps: CoreImageProps,
) {
  // Initialize Lottie animation for email validation
  const lottiePlayer = useLottiePlayer({
    path: '/email-validated.json',
  });

  const url: string = imageProps.src.replace(
    String(SettingsService.env.S3_BUCKET_BASE_URL),
    String(SettingsService.env.CF_DISTRIBUTION),
  );

  return (
    <div className={`${styles.container} ${styles['container--no-padding']}`}>
      {/* <div className={styles.container__lottie} ref={lottieAnimationRef} /> */}
      <LottieOrImage
        image={`${url}/artworks/key.png`}
        lottie={lottiePlayer}
        classList={{
          lottie: styles.container__lottie,
          image: styles.container__image,
        }}
      />
      <p className={styles.container__description}>
        <TransTextWithDefault text={label} />
      </p>
      <ConfirmationCodeContent {...props} />
    </div>
  );
}
